import { ModalOptions } from 'ngx-bootstrap/modal';
import { ModalboxComponent } from '../components/modalbox/modalbox.component';

/**
 * @returns Modal Options with standard configuration
 */
export function createModalOptions(): ModalOptions;
/**
 * @param classes classes to add in addition to 'modal-dialog-centered'
 * @returns Modal Options with standard configuration and additional classes
 */
export function createModalOptions(cssClasses: string): ModalOptions;
/**
 * @param classes classes to add in addition to 'modal-dialog-centered'
 * @param initialState initialState Object to pass to Modal
 * @returns Modal Options with standard configuration, additional classes, and initialState Object
 */
export function createModalOptions(
  cssClasses: string,
  initialState: Record<string, unknown>
): ModalOptions;
/**
 * @param initialState initialState Object to pass to Modal
 * @returns Modal Options with standard configuration and initialState Object
 */
export function createModalOptions(
  initialState: Record<string, unknown>
): ModalOptions;
export function createModalOptions(
  arg1?: string | Record<string, unknown>,
  arg2?: Record<string, unknown>
) {
  const options: ModalOptions = {
    ignoreBackdropClick: true,
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
  };

  if (arg1) {
    if (typeof arg1 === 'string') {
      options.class += ` ${arg1}`;
    } else {
      options.initialState = arg1;
    }
  }

  if (arg2) {
    options.initialState = arg2;
  }

  return options;
}

export function deleteFavoriteModalOptions(place: {
  id: number;
  name: string;
}): ModalOptions<ModalboxComponent> {
  const initialState = {
    title: `${place?.name} - Delete Favorite`,
    list: ['Are you sure you want to delete this favorite?'],
    actionButtonText: 'Delete',
    id: place?.id,
    btnClass: 'btn btn-danger',
  };
  const options = createModalOptions(initialState);
  return options as ModalOptions<ModalboxComponent>;
}
